import { Size, size } from './size'

export const resolveSizeValue = (value: number | Size): string => `${typeof value === 'string' ? size[value] : value}px`
